import localeSettings from './locale.settings'

function getApiDocsUrl() {
  // if (process.env.REACT_APP_DOCS_URL) return process.env.REACT_APP_DOCS_URL
  if (!localeSettings.isRtl) return 'https://docs.formaloo.net/'
  return 'https://docs.formaloo.com/'
}

const INVOICE_BUILDER_DASHBOARD = process.env.INVOICE_BUILDER_DASHBOARD
  ? process.env.INVOICE_BUILDER_DASHBOARD
  : `https://invoice.formaloo.com/dashboard`

const GATEWAY_REQUEST_LINK = process.env.GATEWAY_REQUEST_LINK
  ? process.env.GATEWAY_REQUEST_LINK
  : `https://formaloo.com/merchant`

const WORDPRESS_PLUGIN =
  process.env.REACT_APP_WORDPRESS_PLUGIN ||
  'https://wordpress.org/plugins/formaloo-form-builder/'

const FORMALOO_LIVE_URL =
  process.env.REACT_APP_FORMALOO_LIVE_URL || 'https://staging.live.formaloo.com'

const CONTACT_PAGE_URL =
  process.env.REACT_APP_SUPPORT_URL ??
  (localeSettings.LOCALE_IN_USE === 'fa'
    ? 'https://web.formaloo.com/contact-us/'
    : 'https://help.formaloo.com/en/')

const SUPPORT_URL =
  process.env.REACT_APP_SUPPORT_URL ??
  (localeSettings.LOCALE_IN_USE === 'fa'
    ? 'https://web.formaloo.com/contact-us/'
    : 'https://help.formaloo.com/en/')

const CNAME_GUIDE =
  process.env.REACT_APP_SUPPORT_URL ??
  'https://www.formaloo.com/en/blog/custom-domain/'

const PABBLY_INTEGRATION_URL =
  'https://www.formaloo.com/en/how-to-connect-formaloo-with-another-app-in-pabbly-connect/'

const MAKE_INTEGRATION_URL =
  'https://www.formaloo.com/en/how-to-connect-formaloo-with-other-tools-using-make-com/'
const GOOGLE_FONT_API_DOMAIN = 'https://fonts.googleapis.com/css2'

const PRIVACY_POLICY =
  process.env.REACT_APP_PRIVACY_POLICY_URL ??
  process.env.REACT_APP_SUPPORT_URL ??
  'https://www.formaloo.com/en/privacy-policy'

const FORM_SPREADSHEET_SAMPLE =
  process.env.REACT_APP_FORM_SPREADSHEET_SAMPLE ??
  'https://formaloo-en.s3.amazonaws.com/f/test-form-new.xlsx'

const FORM_IMPORT_TUTORIAL =
  process.env.REACT_APP_FORM_IMPORT_TUTORIAL_URL ??
  process.env.REACT_APP_SUPPORT_URL ??
  'https://www.formaloo.com/en/blog/import'

const GSHEET_TUTORIAL_URL =
  process.env.GSHEET_TUTORIAL_URL ??
  'https://www.formaloo.com/en/blog/google-sheets/'

const CUSTOM_EMAIL_NOTIFICATIONS_URL =
  process.env.CUSTOM_EMAIL_NOTIFICATIONS_URL ??
  'https://www.formaloo.com/en/blog/how-to-create-custom-email-notifications/'

const NEW_DASHBOARD_URL =
  process.env.REACT_APP_NEW_DASHBOARD ?? 'https://admin.formaloo.com'

const LEGACY_MIGRATION_HELP_URL =
  process.env.REACT_APP_LEGACY_MIGRATION_HELP_URL ??
  'https://help.formaloo.com/en/articles/9767483-how-to-transfer-your-old-forms-to-the-new-dashboard'

const TUTORIALS_URL = process.env.REACT_APP_TUTORIALS_URL

const CONCIERGE_REQUEST_URL =
  process.env.CONCIERGE_REQUEST_URL ?? 'https://www.formaloo.com/concierge'

const externalUrls = {
  API_DOCS_URL: getApiDocsUrl(),
  INVOICE_BUILDER_DASHBOARD,
  GATEWAY_REQUEST_LINK,
  WORDPRESS_PLUGIN,
  FORMALOO_LIVE_URL,
  CONTACT_PAGE_URL,
  SUPPORT_URL,
  CNAME_GUIDE,
  PABBLY_INTEGRATION_URL,
  GOOGLE_FONT_API_DOMAIN,
  PRIVACY_POLICY,
  FORM_SPREADSHEET_SAMPLE,
  FORM_IMPORT_TUTORIAL,
  MAKE_INTEGRATION_URL,
  GSHEET_TUTORIAL_URL,
  CUSTOM_EMAIL_NOTIFICATIONS_URL,
  NEW_DASHBOARD_URL,
  LEGACY_MIGRATION_HELP_URL,
  TUTORIALS_URL,
  CONCIERGE_REQUEST_URL,
}
export default externalUrls
